/* eslint-disable @typescript-eslint/no-unused-vars */
import * as X from "@/ui";
import { links } from "@/config";

import ChatImage from "@/assets/shared-contact-chat.svg";
import EmailImage from "@/assets/shared-contact-email.svg";

import ImageMobile1 from "@/assets/bucket/shipping-contact-mobile-1.png";
import ImageMobile2 from "@/assets/bucket/shipping-contact-mobile-2.png";
import ImageMobile3 from "@/assets/bucket/shipping-contact-mobile-3.png";
import ImageDesktop1 from "@/assets/bucket/shipping-contact-desktop-1.png";
import ImageDesktop2 from "@/assets/bucket/shipping-contact-desktop-2.png";
import { useShippingPage } from "@/providers/strapi/content/types/singleTypes/shipping-page";
import ReactMarkdown from "react-markdown";


export function ContactSection(props: X.PageProps) {
  return (
    <section id="contact" className={X.clsx(
      "scroll-mt-[120px]",
      "xl:max-w-content xl:mx-auto mb-12 xl:my-20",
    )}>
      <Mobile {...props} />
      <Desktop {...props} />
    </section>
  );
}


function Desktop(props: X.PageProps) {
  const contactCard = useShippingPage('contactUsCard')
  return (
    <div className={X.clsx(X.desktopOnly("flex"), "flex-row gap-12")}>
      <div className="flex-1 flex flex-col">
        <Title {...props} />
        <Content {...props} />
      </div>

      <div className="flex flex-row gap-6">
        {/* <X.Image src={ImageDesktop1} alt={`Contact 1`} className="h-auto w-[264px]" /> */}
        {contactCard.pictures[0] && <X.Image
          src={contactCard.pictures[0].url}
          width={contactCard.pictures[0].width}
          height={contactCard.pictures[0].height}
          unoptimized
          alt={`Contact 1`} className="h-auto w-[264px] rounded-2xl" />}
        {/* <X.Image src={ImageDesktop2} alt={`Contact 2`} className="h-auto w-[264px]" /> */}
        {contactCard.pictures[1] &&
          <div className="relative w-[264px]">
            <X.Image
              src={contactCard.pictures[1].url}
              // width={contactCard.pictures[1].width}
              // height={contactCard.pictures[1].height}
              fill
              unoptimized
              alt={contactCard.pictures[1].name} className="h-auto w-full rounded-2xl object-cover object-[75%_0%]" />
          </div>
          // <X.Image
          //   src={contactCard.pictures[1].url}
          //   width={contactCard.pictures[1].width}
          //   height={contactCard.pictures[1].height}
          //   unoptimized
          //   alt={contactCard.pictures[1].name} className="h-auto w-[264px] rounded-2xl" />
        }
      </div>
    </div>
  );
}


function Mobile(props: X.PageProps) {
  const contactCard = useShippingPage('contactUsCard')
  return (
    <div className={X.clsx(X.mobileOnly())}>
      <Title {...props} />

      <div className="flex flex-row gap-4 mb-12">
        <div className="flex-1 relative">
          {/* <X.Image
            src={ImageMobile1}
            alt="Contact Mobile 1"
            className="w-full"
          /> */}
          {contactCard.pictures[0] &&
            <X.Image
              src={contactCard.pictures[0].url}
              width={contactCard.pictures[0].width}
              height={contactCard.pictures[0].height}
              alt="Contact Mobile 1"
              className="w-full rounded-r-xl"
            />
            //  <X.Image
            //   src={contactCard.pictures[0].url}
            //   // width={contactCard.pictures[0].width}
            //   // height={contactCard.pictures[0].height}
            //   unoptimized
            //   alt={contactCard.pictures[0].name}
            //   className="w-full rounded-r-2xl object-cover"
            //   fill
            // />
          }
        </div>
        <div className="flex-1 flex flex-col gap-4 translate-y-4">
          {/* <X.Image
            src={ImageMobile2}
            alt="Contact Mobile 2"
            className="w-full h-auto"
          /> */}
          {contactCard.pictures[1] && <X.Image
            unoptimized
            src={contactCard.pictures[1].url}
            width={contactCard.pictures[1].width}
            height={contactCard.pictures[1].height}
            alt={contactCard.pictures[1].name}
            className="w-full h-auto rounded-l-2xl"
          />}
          {/* <X.Image
            src={ImageMobile3}
            alt="Contact Mobile 3"
            className="w-full h-auto"
          /> */}
          {contactCard.pictures[2] && <X.Image
            src={contactCard.pictures[2].url}
            width={contactCard.pictures[2].width}
            height={contactCard.pictures[2].height}
            unoptimized
            alt={contactCard.pictures[2].name}
            className="w-full h-auto rounded-l-2xl"
          />}
        </div>
      </div>

      <Content {...props} />
    </div>
  );
}


function Title(props: X.PageProps) {
  // const tr = X.useTranslator<"ko">(props);
  const contactUsCard = useShippingPage('contactUsCard');
  return (
    // <h2 className="text-[34px] xl:text-[48px] [&_strong]:font-medium mx-mobile-margin xl:mx-0 mb-4">
    //   {tr({
    //     en: <>Get <strong>in touch</strong></>,
    //     fr: <>Contactez-<strong>nous</strong></>,
    //     ko: <>문의하기</>,
    //   })}
    // </h2>
    <ReactMarkdown components={{
      p: ({ ...props }) => <h2 {...props} className="text-[34px] xl:text-[48px] [&_strong]:font-medium mx-mobile-margin xl:mx-0 mb-4" />
    }}>
      {contactUsCard.title}
      {/* {tr({
        en: contactUsCard.title,
        fr: contactUsCard.title,
        ko: "문의하기",
        zh: ""
      })} */}
    </ReactMarkdown>
  );
}


function Content(props: X.PageProps) {
  // const tr = X.useTranslator<"ko">(props);

  const buttonStyle = X.clsx(
    "flex flex-row items-center gap-2 p-2 pr-4 bg-surface-gray min-w-[200px] xl:min-w-[300px] rounded-lg",
    "text-[16px] xl:text-[18px] font-medium",
    "cursor-pointer hover:bg-[#eaeaea]",
  );

  const contactUsCard = useShippingPage('contactUsCard');
  return (
    <div>
      {/* <p className="text-[16px] xl:text-[20px] mx-mobile-margin xl:mx-0 mb-6 xl:mb-8 leading-tight">

        {contactUsCard.content}
        {tr({
          en: `We'd be happy to walk you through the process, better understand your specific needs, and answer any questions you may have.We speak multiple languages and we’re here to support you.`,
          fr: `Nous serons ravis de vous fournir plus de détails sur la procédure, de mieux comprendre vos besoins spécifiques et de répondre à vos questions. Nous parlons plusieurs langues et sommes à votre disposition.`,
          ko: `저희는 전 과정을 안내해 드리고, 고객님의 필요에 맞게 맞춤 지원 해 드립니다. 궁금하신 점은 질문을 남겨주시면, 성심껏 답변 드리겠습니다.저희는 다양한 나라의 언어로 원활한 소통이 가능하며, 고객님과의 원활한 소통을 위해 최선을 다하겠습니다.`,
        })}
      </p> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <p {...props} className="text-[16px] xl:text-[20px] mx-mobile-margin xl:mx-0 mb-6 xl:mb-8 leading-tight" />
      }}>
        {contactUsCard.content}
      </ReactMarkdown>

      <div className="flex flex-col gap-4 items-start mx-mobile-margin xl:mx-0">
        <div className={X.clsx(buttonStyle, "X-Open-Intercom")}>
          <X.Image src={ChatImage} alt="Chat" className="h-[40px] w-auto" />
          {/* <div>{tr({
            en: `Chat with us`,
            fr: `Contactez-nous via le chat`,
            ko: `채팅으로 문의하기`,
          })}</div> */}
          <div>
            <ReactMarkdown>
              {contactUsCard.byChat}
            </ReactMarkdown>
          </div>
          {/* <div>{tr({
            en: contactUsCard.byChat,
            fr: contactUsCard.byChat,
            ko: `채팅으로 문의하기`,
            zh: ""
          })}</div> */}
        </div>

        <X.ExternalLink href={`mailto:${links.email.support}`} className={buttonStyle}>
          <X.Image src={EmailImage} alt="email" className="h-[40px] w-auto" />
          <div>
            <ReactMarkdown>
              {contactUsCard.byEmail}
            </ReactMarkdown>
            {/* {tr({
            en: contactUsCard.byEmail,
            fr: contactUsCard.byEmail,
            ko: `이메일로 문의하기`,
            zh: ""
          })} */}
          </div>
        </X.ExternalLink>
      </div>
    </div>
  );
}
